import { Product } from '@news-mono/web-common'

export const getNielsenProgramName = (product: Product) => {
    switch (product) {
        case Product.SevenNews:
            return '7NEWS Videos'
        case Product.PerthNow:
            return 'PerthNow Videos'
        case Product.TheWest:
            return 'The West Videos'
        case Product.TheNightly:
            return 'The Nightly Videos'
    }
}

// Update poster frame size to match hero image
// we will do futher work in the future for responsive poster frames.
export const getImageWidth = (product: Product) => {
    switch (product) {
        case Product.PerthNow:
            return 1024 //668
        case Product.TheWest:
            return 1024 //810
        case Product.SevenNews:
            return 1024 //650
        // Todo: update this when available
        case Product.TheNightly:
            return 1024 //810
    }
}
